export const fontOptions = [
  {
    size: "small",
    name: "A",
    color: "black",
    fontSize: "13px",
    showImage: true,
  },
  {
    size: "medium",
    name: "A",
    color: "black",
    fontSize: "18px",
    showImage: true,
  },
  {
    size: "large",
    name: "A",
    color: "black",
    fontSize: "24px",
    showImage: true,
  },
  {
    size: "extra-large",
    name: "A",
    color: "black",
    fontSize: "30px",
    showImage: false,
  },
  {
    size: "extra-extra-large",
    name: "A",
    color: "black",
    fontSize: "36px",
    showImage: false,
  },
]

export const bgOptions = [
  {
    size: "",
    name: "X",
    bg: "white",
    color: "white",
  },
  {
    size: "",
    name: "Y",
    bg: "#dcdcd9",
    color: "#dcdcd9",
  },
  {
    size: "",
    name: "C",
    bg: "#FEEEE4", // 40% mas claro que #FDE2D2
    color: "#FEEEE4",
  },
  // color azul
  {
    size: "",
    name: "B",
    bg: "#E8EFF9", // 40% mas claro que #D8E4F1
    color: "#E8EFF9",
  },
  // color verde
  {
    size: "",
    name: "G",
    bg: "#E7F9E8", // 40% mas claro que #D7F1D8
    color: "#E7F9E8",
  },
]

export const fontFamilyOptions = [
  {
    size: "",
    name: "Poppins Regular",
    icon: "Poppins",
    label: "Poppins",
    active: false,
  },
  {
    size: "",
    name: "OpenDyslexic Regular",
    icon: "OpenDyslexic",
    label: "Dyslexia",
    active: false,
  },
  {
    size: "",
    name: "EduNSWACTFoundation-Regular",
    icon: "EduFundation",
    label: "Edu NSW ACT",
    active: false,
  },
  {
    size: "",
    name: "GochiHand-Regular",
    icon: "GochiHand",
    label: "Gochi Hand",
    active: false,
  },
  {
    size: "",
    name: "McLaren-Regular",
    icon: "McLaren",
    label: "McLaren",
    active: false,
  },
  {
    size: "",
    name: "PatrickHand-Regular",
    icon: "PatrickHand",
    label: "Patrick Hand",
    active: false,
  },
  {
    size: "",
    name: "PlaypenSans-Regular",
    icon: "PlaypenSans",
    label: "Playpen Sans",
    active: false,
  },
  {
    size: "",
    name: "PoiretOne-Regular",
    icon: "PoiretOne",
    label: "Poiret One",
    active: false,
  },
  {
    size: "",
    name: "Quicksand-Regular",
    icon: "Quicksand",
    label: "Quicksand",
    active: false,
  },
]

export const DEFAULT_TEXT_BG_COLOR = bgOptions?.length - 1
